import { TranslateLoader, provideTranslateService } from '@ngx-translate/core';
import {
  ConfigLoader,
  DefaultConfigLoader,
  HttpClientLoaderTranslation,
  ServerSettingsService,
  SettingsService,
  W3hostnameInterceptor,
  COMMONS_ENVIRONMENT,
  EnvironmentConfigLoader,
} from '@infodata-group/inf-commons';
import { HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';
import { AccountOauthInterceptor } from '../interceptor/account-oauth.interceptor';
import { environment } from '../../environments/environment';

export const commonsProvidersFrom = [

];

export const commonsProviders = [
  ...provideTranslateService({
    loader: {
      provide: TranslateLoader,
      useFactory: HttpClientLoaderTranslation,
      deps: [HttpClient],
    },
  }),
  { provide: COMMONS_ENVIRONMENT, useValue: environment },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: AccountOauthInterceptor,
    multi: true,
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: W3hostnameInterceptor,
    multi: true,
  },
  { provide: SettingsService, useClass: ServerSettingsService },
  { provide: ConfigLoader, useClass: EnvironmentConfigLoader },
];
